import { lazy } from "react";

export const LazyAppModals = lazy(() =>
  import(
    /* webpackChunkName: "retailer-app-modals" */ "@faire/retailer-visitor-shared/components/App/AppModals/AppModals"
  ).then((m) => ({ default: m.AppModals }))
);

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
LazyAppModals.preload = () =>
  import(
    /* webpackChunkName: "retailer-app-modals" */ "@faire/retailer-visitor-shared/components/App/AppModals/AppModals"
  ).then((m) => ({ default: m.AppModals }));
